import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import SiteDisabledScreen from './SiteDisabledScreen';
import { store } from './store';
import { checkEnvVars } from './utils/envCheck';
import { initSentry } from './utils/sentry';
import './utils/responsive.css';

checkEnvVars();
initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));

if (process.env.REACT_APP_SITE_DISABLED === 'true') {
    root.render(<SiteDisabledScreen />);
} else {
    root.render(
        <Provider store={store}>
            <App />
        </Provider>
    );
}
